<template>
    <div class="column">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Issued Date</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-calendar-alt"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input v-model="issued_date" type="date" class="input" :disabled="isLocked"/>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Due Date</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-calendar-alt"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input type="date" v-model="due_date"  class="input" :disabled="isLocked"/>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Balance Due (USD)</label>
            </div>
            <div class="field is-expanded remarks">
                <div class="field has-addons">
                    <p class="control">
                        <a class="button is-static">
                            <i class="fas fa-dollar-sign"></i>
                        </a>
                    </p>
                    <p class="control remarks">
                        <input class="input" v-model="balance_due_usd" placeholder="what is it?" readonly :disabled="isLocked">
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        props:['car'],
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            issued_date: {
                get() {
                    return this.$store.getters.getProformaInvoice.issued_date
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'issued_date', value: value })
                }
            },
            due_date: {
                get() {
                    return this.$store.getters.getProformaInvoice.due_date
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'due_date', value: value })
                }
            },
            balance_due_usd: {
                get() {
                    return this.$store.getters.getProformaInvoice.balance_due_usd
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'balance_due_usd', value: value })
                }
            }
        }

    }
</script>

<style scoped>
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    .is-static {
        min-width: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceDates.vue